// extracted by mini-css-extract-plugin
export default {"cardGrid":"ReportSectionRenderer_cardGrid__MEEP8","sectionBlock":"ReportSectionRenderer_sectionBlock__+0S4G","sectionHeading":"ReportSectionRenderer_sectionHeading__NQRVu"};